import { useEffect, useState } from "react"
import { useAuthContext } from "../hooks/useAuthContext"
import { useBookingsContext } from "../hooks/useBookingsContext"
import BookingSummary from "../components/BookingSummary"
import { constants } from "../constants"
import { strings } from "../strings"

const BookingOverview = ({ type }) => {
    const [error, setError] = useState(null)
    const { user, allUsers, dispatch: userDispatch } = useAuthContext()
    const { bookedLaundrySlots, bookedBalconySlots, dispatch } = useBookingsContext()

    useEffect(() => {

        const typeHeaders = type === constants.balconyType ? {
            'Authorization': `Bearer ${user.token}`,
            'facility': strings.balcony.balcony
        } : {
            'Authorization': `Bearer ${user.token}`,
            'facilityID': 0 
        }

        const fetchBookings = async () => {
            setError(null)

            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/bookings/laundry', {
                headers: typeHeaders
            })
            const json = await response.json()

            if (!response.ok) {
                setError(json.msg)
            }

            if (response.ok) {
                setError(null)

                if (type === constants.balconyType) {
                    dispatch({ type: 'SET_BOOKED_BALCONY_SLOTS', payload: json })
                } else {
                    dispatch({ type: 'SET_BOOKED_LAUNDRY_SLOTS', payload: json })
                }
            }
        }

        const fetchUsers = async () => {
            setError(null)
            
            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/user/all', {
                headers: {
                    'Authorization': `Bearer ${user.token}`,
                }
            })
            const json = await response.json()
            
            if (!response.ok) {
                setError(json.msg)
            }
            
            if (response.ok) {
                setError(null)
                userDispatch({ type: 'ALL_USERS', payload: json.filter(user => { return user.userID !== "admin" }) })
            }
        }

        if (user) {
            fetchBookings()
            fetchUsers()
        }

    }, [dispatch, user, userDispatch, type])

    return (
        <div className="admin-tab">
            {((type === constants.laundryType) && allUsers && bookedLaundrySlots) && <BookingSummary users={allUsers} bookings={bookedLaundrySlots} type={type} />}
            {((type === constants.balconyType) && allUsers && bookedBalconySlots) && <BookingSummary users={allUsers} bookings={bookedBalconySlots} type={type} />}

            {error && <div className="error">{error}</div>}
        </div>
    )
}

export default BookingOverview